import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { TrendingUp } from 'lucide-react';

export const MetricCard = ({ label, value, icon: Icon, color, trend }) => {
  const colors = { 
    blue: 'from-blue-100 border-blue-200', 
    emerald: 'from-emerald-100 border-emerald-200', 
    green: 'from-green-100 border-green-200', 
    amber: 'from-amber-100 border-amber-200', 
    purple: 'from-purple-100 border-purple-200',
    red: 'from-red-100 border-red-200'
  };
  const iconColors = { 
    blue: 'text-blue-600', 
    emerald: 'text-emerald-600', 
    green: 'text-green-600', 
    amber: 'text-amber-600', 
    purple: 'text-purple-600',
    red: 'text-red-600'
  };
  return (
    <Card className={`bg-gradient-to-br ${colors[color] || colors.blue} to-white border shadow-sm`}>
      <CardContent className="pt-6">
        <div className="flex items-start justify-between">
          <div>
            <p className="text-sm text-slate-600">{label}</p>
            <p className="text-2xl font-bold text-slate-900 mt-1">{value}</p>
            {trend && (
              <p className="text-xs text-green-600 mt-1 flex items-center gap-1">
                <TrendingUp className="w-3 h-3" />{trend}
              </p>
            )}
          </div>
          <Icon className={`w-8 h-8 ${iconColors[color] || iconColors.blue} opacity-70`} />
        </div>
      </CardContent>
    </Card>
  );
};

export const HealthIndicator = ({ name, status, details }) => {
  const cfg = { 
    healthy: { color: 'bg-green-500', text: 'text-green-600' }, 
    warning: { color: 'bg-yellow-500', text: 'text-yellow-600' }, 
    error: { color: 'bg-red-500', text: 'text-red-600' } 
  };
  const c = cfg[status] || cfg.healthy;
  return (
    <div className="p-4 bg-slate-50 rounded-lg border border-slate-200">
      <div className="flex items-center gap-3">
        <div className={`w-3 h-3 rounded-full ${c.color} animate-pulse`} />
        <div className="flex-1">
          <p className="text-slate-900 font-medium">{name}</p>
          <p className="text-xs text-slate-500">{details}</p>
        </div>
        <Badge variant="outline" className={`${c.text} border-current`}>{status}</Badge>
      </div>
    </div>
  );
};

export default MetricCard;
